import { createContext, Dispatch, SetStateAction } from 'react';

export type CursorVariant =
	| 'lottie-green-visit-case'
	| 'lottie-purple-explore-more'
	| 'lottie-green-explore-more'
	| 'lottie-empty-green'
	| 'lottie-article-green';

export interface CustomCursorActions {
	setIsCursorVisible: Dispatch<SetStateAction<boolean>>;
	setCursorVariant: Dispatch<SetStateAction<CursorVariant | null>>;
}

export const CustomCursorContext = createContext<CustomCursorActions | undefined>(undefined);
